import { reducer as selectedManager } from './selectedManager'
import { reducer as getEmployeesById } from './getEmployeesById'
import { reducer as managerAssignTag } from './managerAssignTag'
import { reducer as managerRemoveTag } from './managerRemoveTag'
import { reducer as managerAssignEmployee } from './managerAssignEmployee'
import { reducer as managerAssignEmployees } from './managerAssignEmployees'
import { reducer as managerRemoveEmployee } from './managerRemoveEmployee'
import { reducer as managerRemoveEmployees } from './managerRemoveEmployees'
import { reducer as managerMoveEmployee } from './managerMoveEmployee'
import { reducer as managerMoveEmployees } from './managerMoveEmployees'
import { reducer as managerUpdate } from './managerUpdate'
import { reducer as managerAdd } from './managerAdd'
import { reducer as managerAddModal } from './managerAddModal'
import { reducer as managerMoveModal } from './managerMoveModal'
import { reducer as managerDelete } from './managerDelete'
import { reducer as managerMove } from './managerMove'
import { reducer as getManagersList } from './getManagersList'
import { reducer as managersRemoveFromTag } from './managersRemoveFromTag'
import { reducer as getManagersChildrenById } from './getManagersChildrenById'
import { reducer as statusManager } from './statusManager'
import { reducer as uploadManagers } from './uploadManagers'
import { reducer as uploadManagersAppend } from './uploadManagersAppend'
import { reducer as managersExportExcel } from './managersExportExcel'

export default {
  selectedManager,
  getEmployeesById,
  managerAssignTag,
  managerRemoveTag,
  managerAssignEmployee,
  managerAssignEmployees,
  managerRemoveEmployee,
  managerRemoveEmployees,
  managerMoveEmployee,
  managerMoveEmployees,
  managerUpdate,
  managerAdd,
  managerAddModal,
  managerMoveModal,
  managerDelete,
  managerMove,
  getManagersList,
  managersRemoveFromTag,
  getManagersChildrenById,
  statusManager,
  uploadManagers,
  managersExportExcel,
  uploadManagersAppend
}



// WEBPACK FOOTER //
// ./src/store/manager/index.js